import { useQuery } from '@tanstack/react-query'
import { useSearchParams } from 'next/navigation'

import { QUERY_KEYS } from '~/constants/react-query'
import { useServerRequests } from '~/hooks/useRequests'
import { ReferralCode } from '~/types'
import { captureMessage } from '~/utils/errors'

export const useReferralCode = () => {
  const { serverGetRequest } = useServerRequests()
  const params = useSearchParams()
  const code = params.get('referral') as string

  const fetchReferralCode = async () => {
    const result = await serverGetRequest<{ referralCode: ReferralCode }>({
      path: `/api/public/referral-code/${code}`,
    })

    if (!result) {
      captureMessage('Invalid referral code', {
        tags: { feature: 'referrals' },
        extra: { code },
      })
      return { valid: false }
    }

    return { referralCode: result.data.referralCode, valid: true }
  }

  const query = useQuery({
    queryKey: [QUERY_KEYS.REFERRAL_CODE, code],
    queryFn: fetchReferralCode,
    enabled: !!code,
  })

  return {
    referralCode: query.data?.referralCode,
    isInvalidCode: code && query.data?.valid === false && !query.isLoading,
  }
}
